import { iconList } from "@/lib/get-icon";
import { Component } from "@builder.io/sdk";

export const typesOfMedicalStaffingSolutionsConfig: Component = {
  name: "Types Of Medical Staffing Solutions",
  inputs: [
    {
      name: "id",
      advanced: true,
      type: "string",
      defaultValue: "types-of-medical-staffing-solutions",
      helperText: "Unique identifier for the section",
    },
    {
      name: "title",
      type: "string",
      defaultValue: "Types of Medical Staffing Solutions",
    },
    {
      name: "items",
      type: "list",
      subFields: [
        {
          name: "title",
          type: "string",
          required: true,
        },
        {
          name: "description",
          type: "text",
          required: true,
        },
        {
          name: "icon",
          type: "string",
          enum: iconList,
          required: false,
        },
      ],
      defaultValue: [
        {
          title: "On-Demand Staffing",
          description:
            "Immediate availability and flexibility for unexpected call-offs, patient volume surges, or short-term needs.",
        },
        {
          title: "Supplemental Staffing",
          description:
            "Temporary placements to bridge staffing gaps and to ensure continuity of care for all patients and residents.",
        },
        {
          title: "Direct Hire Placements",
          description:
            "Find the perfect long-term fit for your team with our comprehensive recruitment services.",
        },
      ],
    },
  ],
};
